module.exports = __webpack_public_path__ + "img/btn_confirm3_2recruit.caf40efd.png";